import React from 'react';
import { editReportStyles } from './styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ReportAddUser from './report-add-user';
import UserList from './report-current-users';
import LoadingSpinner from '../loading-spinner';
import EditReportForm from './edit-report-form';

export default function EditReport(props) {
  const classes = editReportStyles();

  return (
    <Grid className={classes.container}>
      <Grid container spacing={2} direction="column">
        <Paper className={classes.paper} elevation={4}>
          <EditReportForm {...props} />
        </Paper>

        <Paper className={classes.paper} elevation={4}>
          <Grid item>
            <ReportAddUser />
          </Grid>
        </Paper>

        <Paper className={classes.paper} elevation={4}>
          <Grid item>
            <UserList />
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
